import { ValidatorFn, AbstractControl } from "@angular/forms";

export function emailValidator(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const forbidden = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(control.value);
		return forbidden ? null : { invalidEmail: { value: control.value } };
	};
}
